import _Abstract from "system/abstract"

export default class Component_FullScreenHtml5Video extends _Abstract {

  constructor(el, options)
  {

    super(el, $.extend(true, 
    {
    }, options), 'component')


    this.initialise()
  }


  initialise()
  {
      
  }


}



/** WEBPACK FOOTER **
 ** ./components/full-screen-html5-video.js
 **/